import React from 'react';
import PropTypes from 'prop-types';
import Loadable from '../../Loadable';

export const TileViewProps = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  link: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      query: PropTypes.object,
    }),
  ]).isRequired,
  imageUrl: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
};

export const TileViewTypes = {
  card: 'TILE_CARD',
  list: 'TILE_LIST',
};

export const TileViewTypeProp = PropTypes.oneOf(
  Object.keys(TileViewTypes).reduce((acc, key) => [
    ...acc,
    key,
    TileViewTypes[key],
  ])
);

const determineComponent = viewType => {
  let type = viewType;
  if (
    !Object.values(TileViewTypes).includes(viewType) &&
    Object.keys(TileViewTypes).includes(viewType.toLowerCase())
  ) {
    type = TileViewTypes[viewType.toLowerCase()];
  }

  switch (type) {
    case TileViewTypes.card:
      return Loadable({
        loader: () => import(/* webpackChunkName: "CardTile" */ `./CardTile`),
      });
    case TileViewTypes.list:
      return Loadable({
        loader: () => import(/* webpackChunkName: "ListTile" */ `./ListTile`),
      });
    default:
      return null;
  }
};

const TileView = ({ viewType = TileViewTypes.card, ...props }) => {
  let Component = determineComponent(viewType);
  if (Component) {
    return <Component {...props} />;
  }
  return null;
};

TileView.propTypes = {
  viewType: TileViewTypeProp,
};

export default TileView;



// WEBPACK FOOTER //
// ./src/common/components/TileView/index.js